import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const PRODUCT = 'Mega Pack Chi Kung';
const buyers = [{
  name: 'María G.',
  location: 'Madrid'
}, {
  name: 'Julián L.',
  location: 'Barcelona'
}, {
  name: 'Carolina P.',
  location: 'Valencia'
}, {
  name: 'Ricardo A.',
  location: 'Sevilla'
}, {
  name: 'Elena B.',
  location: 'Bilbao'
}, {
  name: 'Marta S.',
  location: 'Zaragoza'
}];
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'María G.',
    location: 'Madrid',
    time: 'hace 9 minutos'
  });
  useEffect(() => {
    const initialTimer = setTimeout(() => setIsVisible(true), 15000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        setNotificationData({
          ...randomBuyer,
          time: `hace ${Math.floor(Math.random() * 59) + 1} minutos`
        });
        setIsVisible(true);
      }, 1000);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-66" data-mp="1qzs89o0o05hd">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      type: 'spring',
      stiffness: 340,
      damping: 28
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-xs" role="status" aria-live="polite" data-id="element-67" data-mp="1mx407ijrz2lg">
          <div className="glass-panel p-4 rounded-sm flex items-start gap-3" data-id="element-68" data-mp="1853e7wegbfgz">
            <div className="border border-brand-gold/50 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-69" data-mp="13a68ozgdro8u">
              <CheckIcon className="w-3.5 h-3.5 text-brand-goldDark" data-id="element-70" data-mp="z5yhmvmg9w7g" />
            </div>
            <div data-id="element-71" data-mp="u86s289a2m6f">
              <p className="font-seal text-[9px] uppercase tracking-seal text-brand-muted mb-1.5" data-id="element-72" data-mp="u9rmzyzi874t">
                Compra verificada · {notificationData.time}
              </p>
              <p className="text-sm text-brand-text" data-id="element-73" data-mp="omfriaalxqbr">
                <span className="font-semibold text-brand-purpleDark" data-id="element-74" data-mp="am4x4xa39tlu">
                  {notificationData.name}
                </span>{' '}
                de {notificationData.location} adquirió
              </p>
              <p className="text-sm text-brand-goldDark font-medium" data-id="element-75" data-mp="13aahhix8dgl5">
                {PRODUCT}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};